export const BRANCH_PREFIX = "posthog-code/";
